<template>
  <div>
    <v-menu v-model="menu" :disabled="disabled" v-bind="{
      'offset-y': true,
      'close-on-content-click': false,
      'max-height': $props.menuProps.maxHeight,
      'max-width': $props.menuProps.maxWidth
    }" style="overflow-y: hidden !important" offset-overflow>
      <template #activator="{ on }">
        <div :id="$props.id" @click="on.click">
          <v-autocomplete id="list_wks" v-bind="$props" v-on="$listeners" type="search" hide-details @keydown.prevent=""
            :menu-props="{
              'disabled': true
            }" @click:prepend-inner.native.stop="$emit('click:prepend-inner')"
            @click:append-icon.native.stop="$emit('click:append-icon')">
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
              <slot :name="slot" v-bind="scope" />
            </template>
            <template #append>
              <slot name="append" />
            </template>
            <template #prepend-inner>
              <slot name="prepend-inner" />
            </template>
            <template #append-outer>
              <slot name="append-outer"></slot>
            </template>
          </v-autocomplete>
        </div>
      </template>
      <v-card color="surface" class="pa-4">
          <v-text-field
            :id="`${$props.id ? $props.id + '_' : ''}select2_searchInput`"
            v-model="search"
            ref="searchBox"
            flat
            solo
            dense
            color="accent"
            hide-details
            clearable
            placeholder="Search..."
            @input="$emit('update:search-input', $event)"
            style="min-width: 160px"
          />
      
        <v-list v-bind="$props.menuProps" class="mt-2 overflow-y-auto" :dense="$props.dense" :max-height="257">
          <slot name="prepend-item" />
          <template v-if="computedItems.length">
            <v-list-item :id="`${$props.id ? $props.id + '_' : ''}select2_resultList_item_${index}`"
              v-for="(item, index) in computedItems" :key="index"
              :input-value="computedSelectedList.includes(item[$props.itemValue])" :color="computedColor"
              @click="select(item)">
              <slot name="item" v-bind="{ item }">
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ item[itemText] }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </slot>
            </v-list-item>
          </template>
          <template v-else>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  No data available
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </v-menu>
    <div v-if="!hideDetails" class="v-text-field__details mb-2 px-3">
      <div class="v-messages theme--light error--text" role="alert">
        <div class="v-messages__wrapper">
          <div class="v-messages__message">{{ messagesToDisplay[0] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash/object'
import { VSelect } from 'vuetify/lib'

export default {
  name: 'Select2',
  extends: VSelect,
  props: {
    searchInput: {
      type: String,
      default: () => ''
    }
  },
  data: (vm) => ({
    search: '',
    menu: false,
    valueIndex: [],
    results: vm.value
  }),
  computed: {
    computedItems() {
      if (this.search) {
        return this.$props.items.filter(item => {
          return get(item, this.itemText).toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        })
      }
      return this.$props.items
    },
    computedSelectedList() {
      if (this.multiple) {
        if (this.returnObject) {
          return this.value ? this.value.map(val => get(val, this.itemValue)) : []
        } else {
          return this.value || []
        }
      } else {
        if (this.returnObject) {
          return [get(this.value, this.itemValue)]
        } else {
          return [this.value]
        }
      }
    }
  },
  methods: {
    select(item) {
      if (this.multiple) {
        if (this.returnObject) {
          const currentValue = this.value || [];
          const isItemSelected = currentValue.some(
            val => get(val, this.itemValue) === get(item, this.itemValue)
          );

          if (isItemSelected) {
            this.$emit('input', currentValue.filter(
              val => get(val, this.itemValue) !== get(item, this.itemValue)
            ));
          } else {
            this.$emit('input', [...currentValue, item]);
          }
        } else {
          const currentValue = this.value || [];
          const itemValue = get(item, this.itemValue);

          if (currentValue.includes(itemValue)) {
            this.$emit('input', currentValue.filter(val => val !== itemValue));
          } else {
            this.$emit('input', [...currentValue, itemValue]);
          }
        }
      } else {
        if (this.returnObject) {
          this.$emit('input', item)
        } else {
          this.$emit('input', get(item, this.itemValue))
        }
        this.menu = false
      }
    }
  },
  watch: {
    menu(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.searchBox.focus()
        }, 300)
      }
    },
    value(val) {
      if (!val) {
        this.valueIndex = null
      }
    },
    computedSelectedList() {
      this.$emit('change', this.value)
    },
    search(val) {
      this.$emit('searchItem', val)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-input {
  margin-bottom: 8px !important;
  cursor: pointer !important;
}

.v-input__control {
  pointer-events: none !important;
}

.search {
  position: relative;
  z-index: 100;
  top: 16px;
  left: 0;
  width: calc(100% - 16px);
  outline: none;
  margin-left: 8px;
  margin-right: 8px;
  margin-bottom: 8px;

  input {
    outline: none;
    font-size: 14px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Select2.vue